import React, { useState } from 'react';
import { usePanelConfig } from '../../../../modules/panel';
import OutputTypeForm from '../forms/OutputTypeForm';

/**
 * OutputTypesTab - Çıkış tiplerini kategoriye göre listeler
 */
export default function OutputTypesTab() {
  const { outputTypes, outputCategories, removeOutputType } = usePanelConfig();
  const [editingId, setEditingId] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);

  const sortedCategories = Object.values(outputCategories).sort(
    (a, b) => a.order - b.order
  );

  const handleDelete = (id) => {
    removeOutputType(id);
  };

  if (editingId) {
    return (
      <OutputTypeForm
        outputType={outputTypes[editingId]}
        onDone={() => setEditingId(null)}
      />
    );
  }

  if (showAddForm) {
    return (
      <OutputTypeForm
        outputType={null}
        onDone={() => setShowAddForm(false)}
      />
    );
  }

  return (
    <div>
      {sortedCategories.map(cat => {
        const items = Object.values(outputTypes).filter(
          ot => ot.categoryId === cat.id
        );
        if (items.length === 0) return null;

        return (
          <div key={cat.id}>
            <div className="group-header">
              <span
                className="category-color-dot"
                style={{ background: cat.color, display: 'inline-block', width: 8, height: 8, borderRadius: '50%', marginRight: 6 }}
              />
              {cat.label}
            </div>
            <div className="item-list">
              {items.map(ot => (
                <div key={ot.id} className="item-row">
                  <span className="item-row-label">
                    <strong>{ot.code}</strong> - {ot.label}
                    {ot.defaultPower > 0 && (
                      <span style={{ color: '#888', marginLeft: 6, fontSize: 11 }}>
                        ({ot.defaultPower}W)
                      </span>
                    )}
                  </span>
                  <span className="item-row-actions">
                    <button onClick={() => setEditingId(ot.id)}>Düzenle</button>
                    <button className="delete-btn" onClick={() => handleDelete(ot.id)}>Sil</button>
                  </span>
                </div>
              ))}
            </div>
          </div>
        );
      })}

      <button className="add-item-btn" onClick={() => setShowAddForm(true)}>
        + Yeni Çıkış Tipi Ekle
      </button>
    </div>
  );
}
